;(function () {
  angular
    .module('contrast.auth-settings')
    .directive('serverError', function () {
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, element, attrs, ctrl) {
          element.on('keyup change', function () {
            scope.$apply(function () {
              ctrl.$setValidity('server', true)
            })
          })
        }
      }
    })
})()
